import * as React from 'react';

export type UseInitialLoadingStateProps = {
    isInitialLoading: boolean;
    isInError: boolean;
};

export const useInitialLoadingState = (
    datasource: { status: string; data: unknown[] } | undefined,
): UseInitialLoadingStateProps => {
    const [hasLoadedOnce, setHasLoadedOnce] = React.useState(false);

    React.useEffect(() => {
        if (datasource?.status === 'succeeded' && !hasLoadedOnce) {
            setHasLoadedOnce(true);
        }
    }, [datasource?.status, hasLoadedOnce]);

    const isInitialLoading = React.useMemo(() => {
        if (!datasource) return true;
        if (hasLoadedOnce) return false;
        return datasource.status === 'loading' || datasource.status === 'idle';
    }, [datasource, hasLoadedOnce]);

    const isInError = React.useMemo(() => {
        if (!datasource) return false;
        return datasource.status === 'failed' && !hasLoadedOnce;
    }, [datasource, hasLoadedOnce]);

    return { isInitialLoading, isInError };
};
